import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      const err = error as HttpErrorResponse;

      if (err?.status === 401) {
        const currentUrl = router.url || '';
        const isAlreadyOnLogin = currentUrl.startsWith('/login');
        const isOnAuthCallback = currentUrl.startsWith('/auth/callback');

        if (!isAlreadyOnLogin && !isOnAuthCallback) {
          router.navigate(['/login']);
        }
      }

      return throwError(() => error);
    })
  );
};
